import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[dynamicTop]',
    standalone: false
})
export class DynamicTopDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}

@Directive({
    selector: '[dynamicTabs]',
    standalone: false
})
export class DynamicTabsDirective {
  constructor(public viewContainerRef: ViewContainerRef) {}
}
